<template>
  <div>
    <a-tabs>
      <a-tab-pane :tab="v.menu_name" v-for="v in homeList" :key="v.id">
        <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='v.children'>
          <template v-slot:action="{ record }">
            <a-button type="primary" @click='checkBnt(record,v.menu_name)' :ghost="!record.select">{{!record.select ? "选择":"已选择"}}
            </a-button>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <div class="s_flex_center m-t-10">
      <a-button type="primary" @click='confirm'>确定</a-button>
    </div>
  </div>
</template>

<script>
  import { onMounted, reactive, ref, toRefs } from "@vue/runtime-core";
  import { iscode } from "@/utils/app";
  import { message } from 'ant-design-vue';
  import { getDealerUsedMenu } from '@/api/dealer'
  const columns = [
    {
      title: "应用名称",
      dataIndex: "menu_name",
      key: "menu_name",
    },
    {
      title: "操作",
      key: "action",
      width: 150,
      slots: { customRender: "action" },
    },
  ];
  export default {
    name: "moduleSelect",
    props: {
      selectList: {
        type: Array,
      }
    },
    setup(props, { emit }) {
      const state = reactive({
        selectList: [],
        homeList: [
          {
            name: "云店管理",
            children: [
              {
                name: "云店订单",
                icon: "yddd",
                checked: false,
                url: "/pages/order/order_list?current=0",
              },
              {
                name: "财务中心",
                icon: "cwzx",
                checked: false,
                url: "/pages/finance_center/index",
              },
              {
                name: "直播海报",
                icon: "zbhb",
                checked: false,
                url: "/pages/live/index",
              },
              {
                name: "秒杀海报",
                icon: "mshb",
                checked: false,
                url: "/pages/seckill/index",
              },
              {
                name: "拼团海报",
                icon: "pthb",
                checked: false,
                url: "/pages/group/index",
              },
            ]
          },
          {
            name: "智能防窜",
            children: [
              {
                name: "出货扫描",
                icon: "chsm",
                checked: false,
                url: "/pages/anti_fleeing_goods/scanCodeForGoods",
              },
              {
                name: "退货扫描",
                icon: "thsm",
                checked: false,
                url: "/pages/anti_fleeing_goods/returnsManagement",
              },
              {
                name: "出货记录",
                icon: "chjl",
                checked: false,
                url: "/pages/anti_fleeing_goods/shipmentRecord",
              },
              {
                name: "商品签收",
                icon: "spqs",
                checked: false,
                url: "/pages/anti_fleeing_goods/commodityReceipt"
              },
              {
                name: "商品追踪",
                icon: "spzz",
                checked: false,
                url: "",
                type: 'scanCode'
              },
            ]
          },
          {
            name: "资产管理",
            children: [
              {
                name: "我的积分",
                icon: "wdjf",
                checked: false,
                url: "/pages/my_points/index",
              },
              {
                name: "我的优惠券",
                icon: "wdyhq",
                checked: false,
                url: "/pages/my_coupon/index",
              },
              {
                name: "我的礼品",
                icon: "wdlp",
                checked: false,
                url: "/pages/my_prize/index",
              },
            ]
          },
          {
            name: "角色管理",
            children: [
              {
                name: "经销商管理",
                icon: "jxsgl",
                checked: false,
                url: "/pages/dealer/dealer",
              },
              {
                name: "推荐经销商",
                icon: "tjjxs",
                checked: false,
                url: "/pages/dealer/popularizeDealer",
              },
              {
                name: "门店管理",
                icon: "mdgl",
                checked: false,
                url: "/pages/store/store",
              },
              {
                name: "业务员管理",
                icon: "ywygl",
                checked: false,
                url: "/pages/clerk/achievement",
              },
            ]
          },
          {
            name: "报销",
            children: [
              {
                name: "申请报销",
                icon: "sqbx",
                checked: false,
                url: "/pages/expense_account/applyExpenseAccount?type=self",
              },
              {
                name: "下级报销",
                icon: "xjbx",
                checked: false,
                url: "/pages/expense_account/superiorExpenseAccount?type=sub",
              },
              {
                name: "上级报销",
                icon: "sjbx",
                checked: false,
                url: "/pages/expense_account/superiorExpenseAccount?type=sup",
              },
              {
                name: "给下级报销",
                icon: "gxjbx",
                checked: false,
                url: "/pages/expense_account/giveExpenseAccount",
              },
            ]
          },
          {
            name: "订货管理",
            children: [
              {
                name: "发货管理",
                icon: "fhgl",
                checked: false,
                url: "/pages/order_goods/deliveryManagement",
              },
              {
                name: "售后管理",
                icon: "shgl",
                checked: false,
                url: "/pages/order_goods/afterSale",
              },
              {
                name: "下级订货管理",
                icon: "xjdhgl",
                checked: false,
                url: "/pages/order_goods/orderManagement",
              },
              {
                name: "当面交易核销",
                icon: "dmjyhx",
                checked: false,
                url: "",
                type: "writeOff"
              }
            ]
          },
          {
            name: "其他功能",
            children: [
              {
                name: "退货地址",
                icon: "thdz",
                checked: false,
                url: "/pages/order_goods/returnAddress",
              },
              {
                name: "物流公司",
                icon: "wlgs",
                checked: false,
                url: "/pages/freight/company_list",
              },
              {
                name: "运费模板",
                icon: "yfmb",
                checked: false,
                url: "/pages/freight/index?type=2",
              }
            ]
          },
        ],
      })
      //获取菜单
      const getMenu = async () => {
        let result = await getDealerUsedMenu().then(res => res.data).catch(error => error);
        if (iscode(result)) {
          state.homeList = result.data;
          initData();
        } else {
          message.error(result.msg);
        }
      }
      const initData = async () => {
        if (state.selectList || state.selectList.length > 0) {
          state.homeList.forEach((i) => {
            i.children.forEach((k) => {
              if (
                state.selectList.find((v) => {
                  return k.id == v.id;
                })
              ) {
                k.select = true;
              }
            });
          });
        }
      };

      onMounted(() => {
        if (props.selectList) {
          state.selectList = JSON.parse(JSON.stringify(props.selectList));
        }
        getMenu();
      });

      //多选
      const checkBnt = (e,name) => {
        if (!e.select) {
          if (state.selectList.length == 8) {
            message.error("最多添加8个常用菜单")
            return
          }
          state.selectList.push({...e,module:name});
        } else {
          var index = 0;
          state.selectList.forEach((v, k) => {
            if (v.id == e.id) {
              index = k;
            }
          });
          state.selectList.splice(index, 1);
        }
        e.select = !e.select;
      };
      //多选确认
      const confirm = () => {
        emit("select", state.selectList);
      };
      return {
        ...toRefs(state),
        columns,
        checkBnt,
        confirm,
      };
    },
  };
</script>